const isContractorMode = state => state.general.get('isBusinessMode');
const isMobile = state => state.general.get('isMobile');

export const UtilSelectors = Object.freeze({
  isContractorMode,
  isMobile,
});

export default UtilSelectors;
